// extracted by mini-css-extract-plugin
module.exports =  {"root":"TZ_PK5XAh3P9cPF38ObG"};